import React from 'react';
import styles from './container.module.scss';
import { IconWrapper } from '../../../Atoms/icons/Icon';
import Tooltip from '../../../Atoms/Tooltip/Tooltip';
const Header = ({
  setIsNewMail,
  setIsExpanded,
  isExpanded,
  setReply,
  reply,
}) => {
  return (
    <div className={styles.header}>
      <p>{reply?.content?.subject || 'New Message'}</p>
      <div className={styles.icons}>
        <Tooltip content={isExpanded ? 'Collapse' : 'Expand'}>
          <IconWrapper
            icon={isExpanded ? 'collapse' : 'expand'}
            onClick={() => setIsExpanded((prev) => !prev)}
            className={`${styles.close} ${
              isExpanded ? styles.collapseIcon : ''
            }`}
          />
        </Tooltip>
        <Tooltip content='Close'>
          {' '}
          <IconWrapper
            icon='close'
            onClick={() => (
              setIsNewMail(false),
              setIsExpanded(false),
              setReply((prev) => ({
                ...prev,
                show: false,
                type: null,
                content: null,
              }))
            )}
            className={styles.close}
          />
        </Tooltip>
      </div>
    </div>
  );
};

export default Header;
